module.exports = __webpack_public_path__ + "static/media/roblox.99a875fc.png";